<template>
  <div>
    <div v-if="type === 'card'" class="card">
      <div class="nav-bar-item-card">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="nav-bar-btn"
          :class="{ active: activeIndex == index }"
          @click="handleCommand(item, index)"
        >
          <div class="parent">
            {{ item.navTitle }}
          </div>
        </div>
      </div>

      <el-button-group
        v-if="list[activeIndex] && list[activeIndex].children"
        class="children"
      >
        <el-button
          v-for="(chItem, itemIndex) in list[activeIndex].children"
          :key="itemIndex"
          size="mini"
          :type="chActiveIndex == itemIndex ? 'primary' : 'default'"
          @click.stop="handleChildren(chItem, itemIndex)"
        >
          {{ chItem.navTitle }}
        </el-button>
      </el-button-group>
    </div>
    <div v-else>
      <div class="nav-bar-item m-l-20">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="nav-bar-btn"
          :class="{ active: activeIndex == index }"
          @click="handleCommand(item, index)"
        >
          {{ item.navTitle }}
          <span v-if="showTotal">({{ item.total }})</span>
        </div>
      </div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HomeNavBar',

  props: {
    list: {
      type: Array,
      default: () => []
    },

    // 是否显示统计数值
    showTotal: {
      type: Boolean,
      default: true
    },

    type: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      activeIndex: 0,
      chActiveIndex: 0
    }
  },

  computed: {
    ...mapState('user', ['isSigner']),
    ...mapState('router', ['currentWorkbench'])
  },

  watch: {
    currentWorkbench: {
      handler: function(val) {
        if (val) {
          this.activeIndex = 0
        }
      },
      immediate: true
    }
  },

  created() {},

  methods: {
    handleCommand(item, index) {
      this.activeIndex = index
      this.$emit('handleSelect', index, item)
    },
    handleChildren(chItem, index) {
      this.chActiveIndex = index
      this.$emit('handleSelectChild', chItem)
    }
  }
}
</script>

<style scoped lang="scss">
.line {
  height: 1px;
  background: $info-fourth-color;
}
.card {
  overflow-y: hidden;
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}

// ------ 不带子项的tab样式 ------
.nav-bar-item {
  display: flex;

  .nav-bar-btn {
    position: relative;
    margin: 0 8px;
    padding: 10px 8px;
    white-space: nowrap;
    cursor: pointer;
    opacity: 0.8;
    color: $second-text-color;
    &.active {
      opacity: 1;
      color: $primary-color;
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: pixel-to-rem($n: 40);
        height: 2px;
        background: $primary-color;
      }
    }
    &:hover {
      color: $primary-color;
      opacity: 1;
    }
  }
}

// ------ 包含子tab的tab样式 -------
.nav-bar-item-card {
  display: flex;
  position: relative;
  z-index: 9;

  .nav-bar-btn {
    position: relative;
    padding: 10px 20px;
    white-space: nowrap;
    cursor: pointer;
    color: $second-text-color;
    border-top: 1px solid #e4e7ed;
    border-left: 1px solid #e4e7ed;
    border-bottom: 1px solid #e4e7ed;
    z-index: 9999;
    background-color: $white-color;

    &:first-child {
      border-top-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-right: 1px solid #e4e7ed;
      position: relative;
    }
    &.active {
      opacity: 1;
      color: $primary-color;
      border-bottom: 1px solid #fff;
    }
    &:hover {
      color: $primary-color;
      opacity: 1;
    }
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0px;
    width: 100%;
    height: 1px;
    z-index: -2;
    background: #e4e7ed;
  }
}
.children {
  margin-top: 6px;
  margin-left: 6px;
  display: flex;
}
</style>
